import type { InternalAxiosRequestConfig } from 'axios'
import { EGlobalConfig, GUESTMODE } from '@/enums/cacheEnum'
import { useStorage } from '@/hooks/system/useStorage'
import type { RequestOptions } from '@/utils/http/types/axios'
import { ContentTypeEnum, ResultEnum } from '@/enums/httpEnum'
import { useUserStoreWithOut } from '@/store/modules/user'

/**
 * axios 全局请求配置
 * 如果配置无法满足业务需求，请在 @utils/http/axios/index 中修改
 * 以下配置可在指定接口中单独配置
*/
export const axiosSetting: RequestOptions = {
  // 接口地址
  apiUrl: useStorage.ls.get(EGlobalConfig.apiSrc),

  // 接口拼接地址 前缀
  urlPrefix: '',

  joinPrefix: false,

  // post 默认请求类型
  contentType: ContentTypeEnum.JSON,

  // code 名
  // 比如接口返回格式是 { rsCode: 200, data: {}, message: '' }
  // 则 codeField 为 'rsCode'
  // codeField: 'code',

  // 判断请求成功的 code 值, 如果需要多个值判断 请使用数组
  code: [200, 0],

  // 接口返回的 data 自定义值
  // 比如接口返回格式是 { code: 200, result: {}, message: '' }
  // 则 dataField 为 'result'
  // dataField: 'data',

  // 异常提示，具体看接口返回的message
  errMsgField: (data) => {
    if (data.code === ResultEnum.BUILDING || data.code === ResultEnum.LOGINEXP) {
      return ''
    }
    return (data && (data.error || data.message || data.msg))
  },

  // 异常处理
  responseInterceptorsCatch(data) {
    const userStore = useUserStoreWithOut()
    const { code } = data || {}
    const Authorization = useStorage.ls.get(EGlobalConfig.token)
    const { isLoginOut } = toRefs(userStore)

    // 登录过期， 具体根据业务自行判断
    if (code === ResultEnum.LOGINEXP) {
      // 游客 不主动退出登录
      if (Authorization === GUESTMODE) return

      // router.replace('/loginout')

      // // 登陆过期 且有 Authorization 情况下，不主动退出登录
      // if (Authorization || isLoginOut.value) {
      //   useStorage.ls.remove(EGlobalConfig.token)
      //   isLoginOut.value = true
      //   return
      // }
      userStore.loginOut()
    } else if (code === ResultEnum.BUILDING) {
      // 维护中
      userStore.building(data?.data)
    }
  },

  // 请求之前处理config，可全局 对参数加密或添加统一参数
  beforeRequestHook(config: InternalAxiosRequestConfig) {
    let lang = useStorage.ls.get(EGlobalConfig.language) || 'ENG'

    if (lang === 'ZHO') {
      lang = 'CMN'
    }

    lang = !['CMN', 'ENG', 'VIE'].includes(lang) ? 'ENG' : lang
    // 公共参数
    const param = {
      languageType: lang,
    }

    if (config.method !== 'GET') {
      config.data = { ...param, ...config.data }
    } else {
      config.params = { ...param, ...config.params }
    }
  },

  // 请求头全局自定义参数 请在这里统一添加
  requestInterceptors(config: InternalAxiosRequestConfig) {
    // guestMode
    const Authorization = useStorage.ls.get(EGlobalConfig.token)
    // console.log('Authorization', Authorization)
    if (Authorization !== GUESTMODE) {
      config.headers.Authorization = Authorization
    } else {
      delete config.headers.Authorization
    }

    return config
  },

  // 是否携带 自定义 headers 参数
  // 设为false, 则 headers.Authorization 等自定义参数 不再携带
  // withToken: true,

  // 超时时间 默认10秒
  timeout: 30 * 1000,

  // 是否返回原生响应头 比如：需要获取响应头时使用该属性
  // isReturnNativeResponse: false,

  // 需要对返回数据进行处理
  // false 则不进行 code 校验，直接返回接口数据，使用场景：导出文件
  // isTransformResponse: true,

  // 处理请求结果后，是否返回 { code, message, data}, 默认直接返回data
  // isTransformValidateResponse: false,

  // post请求的时候添加参数到url
  // joinParamsToUrl: false,

  // 格式化提交参数时间
  // formatDate: true,

  // 消息提示类型
  // errorMessageMode: 'message',

  //  是否加入时间戳
  // joinTime: true,

  // 是否忽略重复请求
  // ignoreCancelToken: false,
}

